// Which of the two sites this build is. Set at build time via PUBLIC_SITE and
// inlined as a constant, so per-site branches are resolved at compile time and
// prerendered pages bake the right content. See design/DOMAIN_SPLIT.md.
import { PUBLIC_SITE } from '$env/static/public';

const VALID_SITES = ['iliad', 'aqueduct'] as const;
export type Site = (typeof VALID_SITES)[number];

// Fail the build on a missing or invalid value; there is no silent default.
if (!VALID_SITES.includes(PUBLIC_SITE as Site)) {
	throw new Error(
		`PUBLIC_SITE must be one of ${VALID_SITES.join(', ')}; got "${PUBLIC_SITE}". ` +
			'Source local-setup.sh, or set PUBLIC_SITE in the Pages project env vars.'
	);
}

export const SITE: Site = PUBLIC_SITE as Site;
export const IS_AQUEDUCT: boolean = SITE === 'aqueduct';
export const SITE_NAME: string = IS_AQUEDUCT ? 'Aqueduct' : 'Iliad';
